import React, { useEffect, useState, useContext } from 'react'
import { Row, Container, Col } from 'react-bootstrap'
import $ from "jquery";

import CustomSpinner from '../generic/CustomSpinner';

import { ModalContext } from "../../context/modalContext";
import { ConfirmModalContext } from "../../context/confirmModalContext";

import { Accordion, Card, Button } from 'react-bootstrap';
import ComponentTable from '../generic/ComponentsTable';
import AddDestinoHermana from './formularios/AddDestinoHermana';
import Icon from '../generic/Icon';
import { AlertBoxContext } from "../../context/alertBoxContext";


// Images
import deleteIcon from "../../assets/delete.png";
import editIcon from "../../assets/editing.png";

const DestinoHermana = ({ esMonja, userId, hermanaId, datosUsuario, accessLevel, ...props }) => {
    // console.log(esMonja)
    // console.log(userId)
    // console.log(hermanaId)
    // console.log(datosUsuario)
    // Spinner
    const [loading, setLoading] = useState(false);
    const [destinosHermana, setDestinosHermana] = useState({})
    const [provincias, setProvincias] = useState({})
    const [comunidades, setComunidades] = useState({})
    // Contexto
    const { modalSetShow, modalSetTitle, modalSetContent } = useContext(ModalContext);
    // Alertas
    const { addAlert } = useContext(AlertBoxContext);


    // Ventana de confirmación
    const { confirmModalSetShow, confirmModalSetTitle, confirmModalSetContent, confirmModalSetFunction } = useContext(ConfirmModalContext);

    useEffect(() => {
        handleObtenerDestinosHermana()
        handleObtenerProvincias()
    }, [])

    const obtenerProvincias = () => {
        let settings = {
            url: `${process.env.REACT_APP_API_URL}/provincias?ended=false&dg=d`,
            method: "GET",
            xhrFields: {
                withCredentials: true,
            },
        };
        return $.ajax(settings);
    }

    const handleObtenerProvincias = () => {
        setLoading(true);
        obtenerProvincias()
            .then((response) => {
                setProvincias(response);
                setLoading(false);
            })
            .catch((e) => {
                //console.log(e)
                setLoading(false);
            });
    }
    
    //leer destinos
    const obtenerDestinoHermana = () => {
        let settings = {
            url: `${process.env.REACT_APP_API_URL}/hermanas/${hermanaId}/destino`,
            method: "GET",
            xhrFields: {
                withCredentials: true,
            },
        };
        return $.ajax(settings);
    }

    const handleObtenerDestinosHermana = () => {
        setLoading(true);
        obtenerDestinoHermana()
            .then((response) => {
                setDestinosHermana(response);
                setLoading(false);
            })
            .catch((e) => {
                //console.log(e)
                setLoading(false);
            });
    }
    //eliminar destino
    const deleteDestinoHermana = (data) => {
        let settings = {
            url: `${process.env.REACT_APP_API_URL}/hermanas/${hermanaId}/destino/${data}`,
            method: "DELETE",
            xhrFields: {
                withCredentials: true,
            },
        };
        return $.ajax(settings);
    }

    const handleDeleteDestinoHermana = (data) => {
        setLoading(true);
        //console.log(data)
        deleteDestinoHermana(data.id)
            .then(() => {
                addAlert("Exito", `Se ha eliminado el destino correctamente`, "success");
                handleObtenerDestinosHermana()
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
                addAlert("Error", `No se ha podido eliminar el destino`, "danger");
            });
    }
    //POST destino
    const handlePostDestinoHermana = (data) => {
        // console.log(`${process.env.REACT_APP_API_URL}/cursosstj/${idUsuario}`)
        let settings = {
            url: `${process.env.REACT_APP_API_URL}/hermanas/${hermanaId}/destino`,
            method: "POST",
            xhrFields: {
                withCredentials: true,
            },
            data: data,
        };
        return $.ajax(settings);
    };

    //PUT destino
    const handlePutDestinoHermana = (data) => {
        // console.log(`${process.env.REACT_APP_API_URL}/cursosstj/${idUsuario}`)
        let settings = {
            url: `${process.env.REACT_APP_API_URL}/hermanas/${hermanaId}/destino/${data.id}`,
            method: "PUT",
            xhrFields: {
                withCredentials: true,
            },
            data: data,
        };
        return $.ajax(settings);
    };

    const handleForm = (datum, post) => {
        modalSetShow(false);
        setLoading(true);
        if (post) {
            handlePostDestinoHermana(datum)
                .then(() => {
                    setLoading(false);
                    handleObtenerDestinosHermana()
                    addAlert("Éxito", "Se ha añadido el destino correctamente", "success");
                })
                .catch(() => {
                    setLoading(false);
                    addAlert("Error", "Error al agregar el destino", "danger");
                });
        } else {
            handlePutDestinoHermana(datum)
                .then(() => {
                    setLoading(false);
                    handleObtenerDestinosHermana()
                    addAlert("Éxito", "Se ha actualizado el destino correctamente", "success");
                })
                .catch(() => {
                    setLoading(false);
                    addAlert("Error", "Error al actualizar el destino", "danger");
                });
        }


    }

    const procesaFechaInicio = (row) => {
        return row?.startDate;
    }
    const procesaFechaFin = (row) => {
        return row?.endDate;
    }
    const procesaProvincia = (row) => {
        return row?.province?.name;
    }
    const procesaComunidad = (row) => {
        return row?.community?.name;
    }

    // Gestiona la acción que se realiza cuando damos en la imagen de editar cargo
    const editTupla = (row) => {
        //console.log(row)
        return (
            <Icon
                src={editIcon}
                onClick={() => {
                    modalSetShow(true, "80%");
                    modalSetTitle(`Editar destino de la hermana`);
                    modalSetContent(<AddDestinoHermana provincias={provincias} handleForm={handleForm} edicion={row} />);
                }}
                className="d-flex m-auto"
            />
        );

    };

    // Gestiona la acción que se realiza cuando damos en la imagen de eliminar cargo
    const deleteTupla = (row) => {
        return (
            <Icon
                src={deleteIcon}
                onClick={() => {

                    confirmModalSetTitle(`Eliminar destino de la hermana`)
                    confirmModalSetContent(<p> {`¿Está seguro de que quiere eliminar el destino de la hermana?`} </p>)
                    confirmModalSetFunction(() => {
                        handleDeleteDestinoHermana(row)
                    })
                    confirmModalSetShow(true)

                }}
                className="d-flex m-auto"
            />
        );
    };

    const columnasTabla = () => {
        return accessLevel > 8 ? [
            { name: "Fecha de inicio", value: procesaFechaInicio },
            { name: "Fecha de fin", value: procesaFechaFin },
            { name: "Provincia", value: procesaProvincia },
            { name: "Comunidad", value: procesaComunidad },
            { name: "Editar", value: editTupla },
            { name: "Eliminar", value: deleteTupla },
        ]
            :
            [
                { name: "Fecha de inicio", value: procesaFechaInicio },
                { name: "Fecha de fin", value: procesaFechaFin },
                { name: "Provincia", value: procesaProvincia },
                { name: "Comunidad", value: procesaComunidad },
            ]
    }

    return (
        <>
            <div style={{ position: "relative" }}>
                <CustomSpinner animation={"border"} loading={loading} />
                <Accordion defaultActiveKey="1">
                    <Card>
                        <Card.Header>
                            <Accordion.Toggle eventKey="0" as={Button} variant="link">
                                Adscripción / Destino
                            </Accordion.Toggle>
                            {/*accessLevel >= 8 && (
                                <Button
                                    variant="outline-primary"
                                    size="sm"
                                    className="float-right mr-4"
                                    onClick={() => {
                                        modalSetShow(true, "60%");
                                        modalSetTitle("Añadir destino para la hermana");
                                        modalSetContent(<AddDestinoHermana
                                            provincias={provincias}
                                            handleForm={handleForm} />);
                                    }}
                                >
                                    Añadir
                                </Button>
                                )*/}
                        </Card.Header>
                        <Accordion.Collapse eventKey="0">
                            <Card.Body>
                                <p>
                                    <small>(Ordenado de más reciente a más antiguo)</small>
                                    <br></br>
                                    {accessLevel >8 && <small>(RECUERDE que no puede eliminar un destino vencido, ni uno en vigor, ni el último destino de la hermana)</small>}
                                </p>
                                

                                {destinosHermana.length ? <ComponentTable
                                    emptyTableComponent={<p className="m-2">{`No hay destinos para esta hermana`}</p>}
                                    headers={columnasTabla()}
                                    rows={destinosHermana}
                                />
                                    : (
                                        <p>No hay destinos para esta hermana</p>
                                    )}
                                {/*   {cursos.length ? (
                cursos.map((situacion) => {
                  return <SituacionParticular accessLevel={accessLevel} key={situacion.id} situacionParticular={situacion} deleteSituacionParticularState={deleteSituacionParticular} />;
                })
              ) : (
                <p>No hay situaciones particulares actualmente.</p>
              )}*/}

                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                </Accordion>
            </div>
        </>
    )
}

export default DestinoHermana